import React from 'react';
import PropTypes from 'prop-types';

import TruncatedText from 'components/TruncatedText';

import { P } from '@decisiv/ui-components/lib/components/Typography';

export default function TextCell({ text, truncate }) {
  const value = text || '–';

  // Opt-in, like `PlainTextCell`: clamping is only right in a column that
  // declares a `maxWidth`. Without one there is nothing to clamp against, so
  // `white-space: nowrap` would just stop the text wrapping and widen the
  // column — and every value would carry a popover it does not need.
  return truncate ? <TruncatedText text={value} /> : <P>{value}</P>;
}

TextCell.propTypes = {
  text: PropTypes.string,
  truncate: PropTypes.bool,
};

TextCell.defaultProps = {
  text: undefined,
  truncate: false,
};
